import { ReactElement } from 'react';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import GratiMarkerEditor from './GratiMarkerEditor';

type GratiGroupingNameEditorProps = {
  name: string;
  symbol: string;
  backgroundColor?: string;
  symbolPlaceholder?: string;
  nameLabel?: string;
  nameRequired?: boolean;
  disabled?: boolean;
  onChange: (field: 'name' | 'symbol' | 'backgroundColor', value: string) => void;
};

export default function GratiGroupingNameEditor(props: GratiGroupingNameEditorProps): ReactElement {
  const {
    name,
    symbol,
    backgroundColor,
    symbolPlaceholder = '?',
    nameLabel = 'Name',
    nameRequired = false,
    disabled = false,
    onChange,
  } = props;

  return (
    <Stack direction="row" spacing={1} sx={{
      alignItems: "center"
    }}>
      <GratiMarkerEditor
        shape="circle"
        color={backgroundColor}
        value={symbol}
        placeholder={symbolPlaceholder}
        disabled={disabled}
        onChange={(val: string) => onChange('symbol', val)}
        onColorChange={(val: string) => onChange('backgroundColor', val)}
      />
      <TextField
        label={nameLabel}
        value={name}
        onChange={(e) => onChange('name', e.target.value)}
        required={nameRequired}
        fullWidth
        disabled={disabled}
        autoComplete="off"
        slotProps={{ htmlInput: { 'data-1p-ignore': true } }}
      />
    </Stack>
  );
}
